<template>
  <div class="c-content">
    <div style="padding:10px 0;">
      获奖时间：
      <DatePicker
        type="datetimerange"
        format="yyyy-MM-dd"
        placeholder
        style="width: 200px;margin-right: 20px;"
        v-model="auditTime"
      ></DatePicker>是否领取：
      <Select v-model="FormData.isReceive" style="margin-right: 20px;width:100px" clearable>
        <Option v-for="item in cityList" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>领取店铺：
      <Select
        v-model="FormData.storeName"
        style="margin-right: 20px;width:200px"
        filterable
        clearable
      >
        <Option
          v-for="(item,index) in protocolList"
          :value="item.store_name"
          :key="index"
        >{{ item.store_name }}</Option>
      </Select>
      <Input
        v-model="FormData.keyword"
        placeholder="请输入奖品名称、领奖ID、微信名称等关键词"
        clearable
        style="width: 310px"
      />
      <Button type="primary" @click="getselect()" icon="ios-search" style="margin-left: 20px">查询</Button>
      <Button type="primary" @click="Exportlist()" style="margin-left: 20px">导出列表</Button>
    </div>
    <Table border :columns="listColumns" :loading="loading" :data="listData"></Table>
    <div style="margin-top:20px;">
      <Page
        class-name="page-style fr"
        :total="pageTotal"
        @on-change="changepagesize"
        @on-page-size-change="changepage"
        :current.sync="FormData.page"
        show-total
      ></Page>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      xgth5token: "",
      loading: true,
      listData: [],
      auditTime: [],
      listColumns: [
        {
          title: "序号",
          type: "index",
          align: "center",
          width: 80
        },
        {
          title: "微信名称",
          key: "nickname",
          align: "center",
          width: 130
        },
        {
          title: "领奖ID",
          key: "prize_id",
          align: "center"
        },
        {
          title: "奖品名称",
          key: "prize",
          align: "center"
        },
        {
          title: "获奖时间",
          key: "win_time",
          align: "center",
          width: 130
        },
        {
          title: "状态",
          align: "center",
          width: 100,
          render: (h, params) => {
            return params.row.is_receive
              ? h("span", {}, "已领取")
              : h("span", {}, "未领取");
          }
        },
        {
          title: "领取店铺",
          align: "center",
          render: (h, params) => {
            return params.row.is_receive
              ? h("span", {}, params.row.receive_store)
              : h("span", {}, "----");
          }
        },
        {
          title: "领取时间",
          align: "center",
          render: (h, params) => {
            return params.row.is_receive
              ? h("span", {}, params.row.receive_time)
              : h("span", {}, "----");
          }
        }
      ],
      cityList: [
        {
          value: "1",
          label: "已领取"
        },
        {
          value: "2",
          label: "未领取"
        }
      ],
      pageTotal: 0,
      protocolList: [],
      FormData: {
        startTime: "",
        endTime: "",
        keyword: "",
        storeName: "",
        isReceive: "",
        pageSize: 10,
        noPaginate: 1,
        page: 1
      }
    };
  },
  methods: {
    changepagesize(e) {
      this.FormData.page = e;
      // console.log(e);
      this.getdata();
    },
    changepage(e) {
      this.FormData.pageSize = e;
      // console.log(e);
      this.getdata();
    },
    getdata() {
      if (this.FormData.storeName == "全部") {
        this.FormData.storeName = "";
      }
      this.$axios
        .post(
          "/h5/admin/getReceivePrizeList",
          {
            startTime: this.FormData.startTime,
            endTime: this.FormData.endTime,
            keyword: this.FormData.keyword,
            storeName: this.FormData.storeName,
            isReceive: this.FormData.isReceive,
            pageSize: this.FormData.pageSize,
            noPaginate: this.FormData.noPaginate,
            page: this.FormData.page
          },
          {
            headers: {
              Authorization: this.xgth5token
            }
          }
        )
        .then(res => {
          if (res.data.code === 0) {
            this.loading = false;
            // console.log(res.data);
            this.listData = res.data.data.list;
            this.pageTotal = res.data.data.allCount;
            // console.log(this.listData);
          } else {
            this.$Message.error("未获取到中奖列表");
          }
        });
    },
    getselect() {
      var date1 = new Date(this.auditTime[0]);
      var date2 = new Date(this.auditTime[1]);
      var date_value1 =
        date1.getFullYear() +
        "-" +
        (date1.getMonth() + 1) +
        "-" +
        date1.getDate();
      var date_value2 =
        date2.getFullYear() +
        "-" +
        (date2.getMonth() + 1) +
        "-" +
        date2.getDate();
      if (date_value1 !== "NaN-NaN-NaN" && date_value2 !== "NaN-NaN-NaN") {
        this.FormData.startTime = date_value1;
        this.FormData.endTime = date_value2;
      }
      // console.log(this.FormData);
      this.FormData.pageSize = 10;
      this.FormData.noPaginate = 1;
      this.FormData.page = 1;
      this.getdata();
    },
    Exportlist() {
      window.location.href = 'https://api.smalltea.xiaoxxx.cn/h5/admin/ReceivePrizeExport?Authorization=' + this.xgth5token 
                                                                                              + '&startTime=' +  this.FormData.startTime
                                                                                              + '&endTime=' +  this.FormData.endTime
                                                                                              + '&keyword=' +  this.FormData.keyword
                                                                                              + '&storeName=' +  this.FormData.storeName
                                                                                              + '&isReceive=' +  this.FormData.isReceive
                                                                                              + '&pageSize=' +  this.FormData.pageSize
                                                                                              + '&noPaginate=' +  this.FormData.noPaginate
                                                                                              + '&page=' +  this.FormData.page

    }
  },
  mounted() {},
  created() {
    this.xgth5token = localStorage.getItem("xgth5token");
    if (this.xgth5token !== null) {
      //   console.log(this.xgth5token);
    } else {
      this.$router.push({
        path: "/H5BackLogin"
      });
    }
    this.$axios.post("/h5/admin/getStoreList", {}).then(res => {
      if (res.data.code === 0) {
        res.data.data.data[0].store_name = "全部";
        this.protocolList = res.data.data.data;
      } else {
        this.$Message.error("未获取到店铺信息");
      }
    });
    this.getdata();
  }
};
</script>
